import { render, staticRenderFns } from "./ExibirCargoColegiado.vue?vue&type=template&id=c68852a6&scoped=true&"
import script from "./ExibirCargoColegiado.vue?vue&type=script&lang=js&"
export * from "./ExibirCargoColegiado.vue?vue&type=script&lang=js&"
import style0 from "./ExibirCargoColegiado.vue?vue&type=style&index=0&id=c68852a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68852a6",
  null
  
)

export default component.exports